import { render, staticRenderFns } from "./OkrEditForm.vue?vue&type=template&id=20152cdc&"
import script from "./OkrEditForm.vue?vue&type=script&lang=js&"
export * from "./OkrEditForm.vue?vue&type=script&lang=js&"
import style0 from "./OkrEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports